const FinderButton = ({
  currentStep,
  setCurrentStep,
  steps,
  selections,
  getNextStepData,
  handleSeeResults,
  arrowleft,
  arrowright,
  toast,
  handleBack,
}) => {
  return (
    <div className="finder-buttons">
            <div className="arrow-stack">
          {currentStep > 0 && (
             <span cl onClick={handleBack}  className="btn-prev" style={{ fontSize: "19px" }}>
                <img src={arrowleft} alt="back" /> Back
            </span>
          )}
      </div>

      <div className="arrow-stack">
      {currentStep !== 0 && currentStep < steps.length - 1 && (
        <span
          onClick={() => {
            if (!selections[currentStep]?.length) {
              toast.error("Please select at least one option");
              return;
            }

            getNextStepData(currentStep);
            setCurrentStep((prev) => prev + 1);
          }} 
          className="btn-prev"   
        >
          Next <img src={arrowright} alt="next" />
        </span>
      )}

      {currentStep === steps.length - 1 && (
        <button onClick={handleSeeResults} className="btn-prev">
          See Results
        </button>
      )}
      </div>
    </div>
  );
};
export default FinderButton;